// extracted by mini-css-extract-plugin
module.exports = {"v-application":"CartBtn_v-application_2jSTY","text-h1":"CartBtn_text-h1_14TrF","text-h2":"CartBtn_text-h2_3uhdg","btn":"CartBtn_btn_1CUzJ"};